module.exports = __webpack_public_path__ + "img/remove-image.1facec82.svg";